/** English translation table */
import { aiVideoEn } from './aiVideo'
import { domesticEn } from './domestic'
import { publishCenterEn } from './publishCenter'
import { contentAiEn } from './contentAi'
export const en: Record<string, string> = {
  ...aiVideoEn,
  ...domesticEn,
  ...publishCenterEn,
  ...contentAiEn,
  'nav.back_to_list': 'Back to list',
  'shared.ready': 'Shared cloud execution is ready. No Agent installation or API key is required.',
  'shared.unavailable': 'Cloud execution is temporarily unavailable. Please retry later or contact support. No Agent installation is needed.',
  'shared.policy': 'Tasks are queued fairly. Manual browser sessions close automatically after {minutes} minutes. Cloud execution does not include an interactive remote desktop.',
  'shared.queued': 'Your request is queued. The page will update when it completes.',
  'shared.queue_full': 'Your cloud task queue is full. Please wait for existing tasks to finish.',
  'shared.expiring': 'This shared browser session will close within one minute. Please save your work.',
  // Settings page
  'settings.title': 'System Settings',
  'settings.desc': 'Manage company info & team members',
  'settings.basic': 'Basic Settings',
  'settings.team': 'Team Management',
  'settings.company': 'Company Info',
  'settings.company_name': 'Company Name',
  'settings.company_name_hint': 'Displayed in notifications and exports',
  'settings.company_name_placeholder': 'Enter company name',
  'settings.logo': 'Company Logo',
  'settings.logo_hint': 'PNG/JPG/SVG/WebP, recommended 200x200, max 2MB',
  'settings.logo_change': 'Change Logo',
  'settings.timezone': 'Timezone',
  'settings.timezone_hint': 'Affects scheduled tasks and log timestamps',
  'settings.language': 'Language',
  'settings.notification': 'Notification',
  'settings.notification_methods': 'Channels',
  'settings.notification_hint': 'Receive notifications via (publish success/fail, risk alerts, etc.)',
  'settings.notification_email': 'Email',
  'settings.notification_feishu': 'Feishu',
  'settings.notification_sms': 'SMS',
  'settings.security': 'Security',
  'settings.security_options': 'Security Policy',
  'settings.security_hint': '2FA requires verification code; IP whitelist restricts access IP ranges',
  'settings.security_2fa': 'Two-Factor Auth',
  'settings.security_ip': 'IP Whitelist',
  'settings.security_login_alert': 'Login Alert',
  'settings.save': 'Save Settings',
  'settings.reset': 'Reset',
  'settings.save_success': 'Saved',
  'settings.save_failed': 'Save failed',
  'settings.load_failed': 'Failed to load settings',
  'settings.logo_success': 'Logo uploaded',
  'settings.logo_failed': 'Logo upload failed',
  'settings.hero_status': 'Company info autosaves · Notifications and security save separately',
  'settings.member_count': '{count} team members',
  'settings.company_desc': 'Manage company branding and the shared timezone. Set your personal language in your profile.',
  'settings.auto_save': 'Autosave',
  'settings.company_load_error': 'Company information failed to load and cannot be edited yet.',
  'settings.retry_load': 'Retry',
  'settings.logo_alt': 'Company logo',
  'settings.logo_uploading': 'Uploading and saving…',
  'settings.logo_upload_hint': 'Click to replace; uploads save automatically',
  'settings.saving': 'Saving…',
  'settings.name_unsaved': 'Unsaved · Blur the field or press Enter to save',
  'settings.name_saved': 'Saved · Changes save on blur or Enter',
  'settings.loading': 'Loading…',
  'settings.retry_save': 'Retry save',
  'settings.company_display_hint': 'The company name appears in the sidebar and header. Its initial is shown when no logo is uploaded.',
  'settings.timezone_utc': 'Coordinated Universal Time',
  'settings.timezone_shanghai': 'Shanghai',
  'settings.timezone_tokyo': 'Tokyo',
  'settings.timezone_singapore': 'Singapore',
  'settings.timezone_kolkata': 'Kolkata',
  'settings.timezone_dubai': 'Dubai',
  'settings.timezone_london': 'London',
  'settings.timezone_berlin': 'Berlin',
  'settings.timezone_new_york': 'New York',
  'settings.timezone_chicago': 'Chicago',
  'settings.timezone_los_angeles': 'Los Angeles',
  'settings.timezone_sydney': 'Sydney',
  'settings.timezone_auto_save': 'Saves automatically and updates displayed times',
  'settings.timezone_offset_hint': 'Applies to all company members. UTC offset changes automatically for daylight saving time.',
  'profile.language_title': 'Personal Language',
  'profile.language_hint': 'Saves automatically for your account only, without changing other members’ language.',
  'settings.language_zh': 'Simplified Chinese',
  'settings.language_auto_save': 'Saves automatically and updates the interface language',
  'settings.name_invalid': 'Company name must be 1–100 characters; this change was not saved',
  'settings.save_preserved': 'Save failed. Your input was kept; please retry',
  'settings.save_restored': 'Save failed. The previous setting was restored; please select again',
  // Team
  'team.title': 'Team Members',
  'team.invite': 'Invite',
  'team.col_user': 'Member',
  'team.col_role': 'Role',
  'team.col_status': 'Status',
  'team.col_last_login': 'Last Login',
  'team.col_action': 'Action',
  'team.status_active': 'Active',
  'team.status_disabled': 'Disabled',
  'team.remove': 'Remove',
  'team.remove_success': 'Member removed',
  'team.invite_title': 'Invite Member',
  'team.invite_email': 'Email',
  'team.invite_email_placeholder': 'Enter email address',
  'team.invite_role': 'Role',
  'team.invite_role_placeholder': 'Select role',
  'team.invite_cancel': 'Cancel',
  'team.invite_send': 'Send Invite',
  'team.invite_success': 'Invitation sent',
  'team.invite_email_required': 'Please enter email',
  'team.desc': 'Manage member roles, status, and access',
  'team.seats_title': 'Team Member Seats',
  'team.seats_desc': 'The Owner is free and does not use a seat. Pending invitations and active members use seats.',
  'team.seats_purchased': 'Purchased',
  'team.seats_occupied': 'In use',
  'team.seats_remaining': 'Remaining',
  'team.seats_unit': '/seat/{months} months',
  'team.seats_valid_until': 'Valid until {time}',
  'team.seats_standalone': 'Purchased separately from your plan',
  'team.seats_unavailable_desc': 'No longer for sale; existing seats are unaffected',
  'team.seats_unavailable': 'Unavailable',
  'team.seats_buy': 'Buy Seats',
  'team.seats_view': 'View Seats',
  'team.seats_overage': '{count} members exceed your valid seats. Existing members remain, but new invitations are paused until you renew.',
  'team.owner_exempt': 'Owner · No seat required',
  'team.status_invited': 'Pending',
  'team.col_mfa': '2FA',
  'team.mfa_enabled': 'Enabled',
  'team.mfa_disabled': 'Disabled',
  'team.never_logged_in': 'Never signed in',
  'team.resend_invite': 'Resend',
  'team.revoke_invite': 'Revoke',
  'team.edit': 'Edit',
  'team.recover_mfa': 'Recover 2FA',
  'team.edit_title': 'Edit Member',
  'team.nickname': 'Name',
  'team.nickname_placeholder': 'Enter a name',
  'team.status': 'Status',
  'team.enable': 'Enable',
  'team.disable': 'Disable',
  'team.invite_intro': 'Invite a member to this team',
  'team.invite_intro_desc': 'They will activate their account by email and receive the selected role automatically.',
  'team.invite_nickname': 'Member Name',
  'team.invite_nickname_placeholder': 'Enter the member name',
  'team.load_failed': 'Failed to load team members',
  'team.no_seats': 'No team seats are available. Buy seats before inviting a member.',
  'team.no_seat_permission': 'Your role cannot access Team Seats. Ask the tenant Owner to purchase seats.',
  'team.product_unavailable': 'Team seats are no longer for sale; existing seats remain available.',
  'team.revoke_title': 'Revoke this invitation?',
  'team.remove_title': 'Remove “{name}”?',
  'team.revoke_desc': 'The current invitation link will stop working immediately.',
  'team.remove_desc': 'The member account will be disabled and its refresh credentials revoked.',
  'team.remove_confirm': 'Remove',
  'team.revoke_success': 'Invitation revoked',
  'team.resend_success': 'Invitation resent; the previous link is no longer valid',
  'team.nickname_required': 'Enter the member name',
  'team.role_required': 'Select a member role',
  'team.mfa_recovery_title': 'Help {name} recover 2FA?',
  'team.mfa_recovery_desc': 'A recovery link valid for 30 minutes will be sent to the member’s verified email. Administrators cannot view or disable the member’s authenticator.',
  'team.mfa_recovery_send': 'Send Recovery Email',
  'team.mfa_recovery_success': 'Recovery email sent',
  'role.owner': 'Owner',
  'role.operations': 'Operations Manager',
  'role.content_editor': 'Content Editor',
  'role.readonly': 'Read-only',
  // Notification settings
  'notification.title': 'Notification Settings',
  'notification.desc': 'Send publishing, risk, and export updates to selected team members.',
  'notification.scope_what': 'What',
  'notification.scope_what_value': 'Business tasks and results',
  'notification.scope_who': 'Recipients',
  'notification.scope_who_value': 'Selected members with access',
  'notification.scope_when': 'Effective',
  'notification.scope_when_value': 'After you save below',
  'notification.load_failed': 'Notification settings failed to load. Reload before saving.',
  'notification.channels': 'Notification Channels',
  'notification.email': 'Business email notifications',
  'notification.sms_later': 'SMS notifications (coming later)',
  'notification.channel_hint': 'This does not control login security alerts. Verification codes, password resets, and invitation emails are unaffected; in-app notifications always remain available.',
  'notification.recipients': 'Email Recipients',
  'notification.recipients_placeholder': 'Select team members with verified email',
  'notification.recipients_hint': 'Members receive only messages they can access. Export results and nurturing task alerts go only to selected task owners.',
  'notification.events': 'Message Types',
  'notification.events_hint': 'Publish results include success, failure, and pending confirmation. Risk alerts follow existing rules and plan access.',
  'notification.service_unavailable': 'Platform email is not configured. Contact the platform administrator.',
  'notification.rules': 'Delivery Rules and Limits',
  'notification.rules_desc': 'Only new messages are sent after a change. Unsent jobs from the previous subscription are canceled, while in-flight emails may still arrive. Each company gets up to {limit} business-email attempts per day, with two retries per failure. Deferred messages expire after 24 hours.',
  'notification.test_rules': 'Test emails go only to the signed-in user and do not enable subscriptions or login alerts. Limited to once per minute and five times per administrator in 24 hours.',
  'notification.delivery_history': 'Email Delivery History · Business and login alerts (90 days)',
  'notification.refresh': 'Refresh',
  'notification.smtp_hint': '“Accepted by email service” means SMTP accepted the message, not that it reached the inbox. Check spam if it is missing.',
  'notification.empty': 'No delivery records yet. Save a subscription and trigger an event, or send a test email.',
  'notification.not_loaded': 'Settings have not loaded',
  'notification.unsaved': 'Unsaved changes affect business notifications only',
  'notification.synced': 'Business notification settings are synced',
  'notification.reload': 'Reload',
  'notification.cooldown': 'Test cooldown (1 minute)',
  'notification.send_test': 'Send Me a Test Email',
  'notification.save': 'Save Notification Settings',
  'notification.state_loading': 'Loading',
  'notification.state_disabled': 'Disabled',
  'notification.state_enabled': 'Enabled',
  'notification.state_unavailable': 'Email not configured',
  'notification.state_error': 'Delivery issue',
  'notification.state_unknown': 'Pending review',
  'notification.col_event': 'Message Type',
  'notification.col_recipient': 'Recipient',
  'notification.col_status': 'Status',
  'notification.col_attempts': 'Attempts',
  'notification.col_created': 'Created',
  'notification.recipient_removed': 'Removed member',
  'notification.selection_required': 'Select at least one recipient and message type',
  'notification.save_success': 'Notification settings saved',
  'notification.test_queued': 'Test email queued. Refresh delivery history shortly.',
  'notification.event.publish': 'Publish Result',
  'notification.event.alert': 'Risk Alert',
  'notification.event.export': 'Export Result',
  'notification.event.team': 'Team Change',
  'notification.event.nurture': 'Nurturing Task',
  'notification.event.billing': 'Billing Alert',
  'notification.event.login_security': 'Login Security Alert',
  'notification.event.test': 'Channel Test',
  'notification.status.pending': 'Waiting to send',
  'notification.status.sending': 'Sending',
  'notification.status.sent': 'Accepted by email service',
  'notification.status.retry': 'Waiting to retry',
  'notification.status.failed': 'Failed',
  'notification.status.cancelled': 'Canceled',
  'notification.status.expired': 'Expired',
  'notification.status.unknown': 'Delivery unconfirmed',
  // Security settings
  'security.title': 'Security Settings',
  'security.desc': 'Protect TikFlow admin accounts and send alerts directly to the affected user.',
  'security.scope_alert': 'Login alerts',
  'security.scope_alert_value': 'Sent to the signed-in account',
  'security.scope_mfa': 'Two-factor auth',
  'security.scope_mfa_value': 'Set up by each member',
  'security.scope_policy': 'Company policy',
  'security.scope_policy_value': 'Managed by the Owner',
  'security.scope_ip': 'IP allowlist',
  'security.scope_ip_value': 'Restricts admin access by network',
  'security.load_failed': 'Security settings failed to load. Reload before saving.',
  'security.login_email': 'TikFlow Login Email Alerts',
  'security.login_enable': 'Enable login alerts for team members',
  'security.login_hint_1': 'Alerts go to the user’s verified email for password or Google sign-ins from a new environment, and temporary lockouts after repeated password failures. Available on all plans.',
  'security.login_hint_2': 'This does not use business-notification recipients and is independent of that setting. It alerts on TikFlow admin logins, not TikTok environment logins, and does not add a login block.',
  'security.service_unavailable': 'Email is not configured. Contact the platform administrator. Existing policies can still be disabled.',
  'security.mfa_policy': 'Company Two-Factor Authentication Policy',
  'security.mfa_force': 'Require an authenticator for every team member',
  'security.mfa_required': 'Two-factor authentication is required by your company',
  'security.mfa_optional': 'Members may choose whether to enable two-factor authentication',
  'security.mfa_grace': 'Existing members have {days} days to finish setup after this is enabled. New members must set it up on first sign-in. Available on all plans.',
  'security.mfa_progress': '{enabled} of {total} active members have finished setup. Members manage authenticators and recovery codes in Profile; administrators cannot view their secrets or recovery codes.',
  'security.mfa_bind_first': 'Set up your authenticator in Profile and save the recovery codes before requiring it company-wide.',
  'security.ip_policy': 'Admin IP Allowlist',
  'security.ip_enable': 'Allow TikFlow admin access only from listed networks',
  'security.enabled': 'Enabled',
  'security.disabled': 'Disabled',
  'security.ip_hint': 'Available on Business and Enterprise only. It does not affect Agents, TikTok browser proxies, or third-party callbacks.',
  'security.current_ip': 'Current public IP:',
  'security.ip_unknown': 'Unknown',
  'security.ip_upgrade': 'Your plan does not include the admin IP allowlist. Upgrade to Business or Enterprise.',
  'security.ip_save_warning': 'When saving, the server verifies that your current public IP remains allowed; otherwise it rejects the change.',
  'security.ip_name_placeholder': 'Name, e.g. Guangzhou office',
  'security.ip_cidr_placeholder': 'IP or CIDR',
  'security.delete': 'Delete',
  'security.add_address': 'Add Address',
  'security.add_current_ip': 'Add Current IP',
  'security.rules': 'Login Alert Rules and Limits',
  'security.rules_desc_1': 'Alerts are sent for the first recorded login environment, IP/browser-system combinations not seen in 30 days, and temporary lockouts. Up to 20 combinations are remembered. This is not exact device recognition or geolocation; network and proxy changes can trigger alerts without implying account compromise.',
  'security.rules_desc_2': 'Signing out repeatedly, refreshing, and token renewal do not repeat alerts. Each member is limited to one email per 10 minutes and five per 24 hours, plus a platform-wide limit. Alerts older than one hour are not sent and excess alerts are not replayed.',
  'security.rules_desc_3': 'Off by default. Changes cancel old unsent jobs, while in-flight mail may still arrive. Delivery status appears in Notification Settings.',
  'security.not_loaded': 'Settings have not loaded',
  'security.unsaved': 'You have unsaved security policy changes',
  'security.synced': 'Login security settings are synced',
  'security.reload': 'Reload',
  'security.save': 'Save Security Settings',
  'security.state_loading': 'Loading',
  'security.state_disabled': 'Login alerts disabled',
  'security.state_enabled': 'Login alerts enabled',
  'security.state_unavailable': 'Email not configured',
  'security.state_error': 'Load failed',
  'security.state_unknown': 'Pending review',
  'security.save_success': 'Security settings saved',
  'security.current_network': 'Current network',
  // User navigation and page titles
  'nav.upgrade': 'Upgrade Plan',
  'nav.unlock_all': 'Unlock all features',
  'nav.price_from': 'From ¥999/month',
  'nav.company_settings': 'Open company settings',
  'nav.current_company': 'Current company',
  'nav.plan_center': 'Plans',
  'nav.notification_center': 'Notification center',
  'nav.unread': 'Notification center · {count} unread',
  'nav.mfa_grace': 'Your company requires two-factor authentication. Finish setup by {deadline}.',
  'nav.bind_now': 'Set Up Now',
  'nav.deadline_unknown': 'the required date',
  'nav.group.home': 'Workspace',
  'nav.group.accounts': 'Accounts',
  'nav.group.nurture': 'Nurturing',
  'nav.group.assets': 'Content',
  'nav.group.publish': 'Publishing',
  'nav.group.risk': 'Risk & Security',
  'nav.group.system': 'System',
  'nav.group.billing': 'Billing',
  'nav.group.profile': 'Profile',
  'route.Login': 'Sign In',
  'route.Logout': 'Sign Out',
  'route.Dashboard': 'Workspace Home',
  'route.Accounts': 'Environment Management',
  'route.BindAccount': 'Import Environments',
  'route.BatchImport': 'Import Environments',
  'route.GroupManage': 'Environment Groups',
  'route.ProxyManage': 'Proxy Management',
  'route.HealthAnalysis': 'Account Health',
  'route.AccountDetail': 'Environment Details',
  'route.NurtureStrategies': 'Nurturing Strategies',
  'route.StrategyConfig': 'Strategy Settings',
  'route.StrategyEdit': 'Edit Strategy',
  'route.NurtureMonitor': 'Nurturing Monitor',
  'route.ExecConsole': 'Nurturing Console',
  'route.ExecConsoleDetail': 'Nurturing Console',
  'route.NurtureAnalytics': 'Nurturing Analytics',
  'route.NurtureHealth': 'Account Health',
  'route.Assets': 'Asset Library',
  'route.PublishTasks': 'Publication Tasks',
  'route.PublishCreate': 'New Publish Task',
  'route.PublishResults': 'Publish Results',
  'route.PublishSchedule': 'Smart Scheduling',
  'route.PublishCalendar': 'Publish Calendar',
  'route.RiskCenter': 'Risk Alerts',
  'route.RiskIntel': 'Intelligence Library',
  'route.BanRate': 'Ban Rate',
  'route.AuditLogs': 'Audit Logs',
  'route.LoginLogs': 'Login Logs',
  'route.BillingPlans': 'Plans',
  'route.BillingTeamSeats': 'Team Seats',
  'route.BillingUsage': 'Resource Usage',
  'route.BillingInvoices': 'Billing History',
  'route.Roles': 'Roles & Permissions',
  'route.Settings': 'System Settings',
  'route.DataExport': 'Data Export',
  'route.SystemAuditLogs': 'Audit Logs',
  'route.Notifications': 'Notification Center',
  'route.Profile': 'Profile',
  'route.AccessDenied': 'Access Denied',
  'route.Prototype': 'Prototype Preview',
  'guard.mfa_required': 'Your company requires two-factor authentication. Finish setup first.',
  'guard.permission_denied': 'Your role does not have access to this page.',
  'guard.entitlements_failed': 'Plan access failed to load. Try again shortly.',
  'guard.feature_unavailable': 'Your current plan does not include this feature. Upgrade to continue.',
  'request.environment_quota_full': 'Environment Limit Reached',
  'request.plan_unsupported': 'Not Available on Your Plan',
  'request.quota_detail': ' ({used}/{limit} used)',
  'request.view_plans': 'View Plans',
  'request.later': 'Maybe Later',
  'request.plan_restricted': 'This action is limited by your current plan.',
  'request.failed': 'Request failed',
  'request.network_denied': 'Your current network is not allowed by company policy.',
  'request.network_error': 'Network error',
  'request.mfa_required': 'Set up two-factor authentication first.',
  'request.agent_required_title': 'Set Up and Start TikFlow Agent',
  'request.agent_required_intro': 'This action requires an online Agent node. Follow these steps:',
  'request.agent_required_step_installed': 'Already installed: start the TikFlowAgent Windows service and make sure AdsPower is running with its Local API enabled.',
  'request.agent_required_step_new': 'Not installed: get the Windows installer from your administrator, then select Deploy Agent to create a one-time enrollment code. Contact your administrator if you do not have deployment permission.',
  'request.agent_required_step_retry': 'Wait until the node shows online, then return here and add the proxy again.',
  'request.deploy_agent': 'Deploy Agent',
  'reauth.title': 'Confirm Your Identity',
  'reauth.confirm': 'Confirm and Continue',
  'reauth.password': 'Current Company Password',
  'reauth.email_code': 'Login Email Code',
  'reauth.code_placeholder': '6-digit code',
  'reauth.resend': 'Resend',
  'reauth.send': 'Send Code',
  'reauth.mfa_code': 'Authenticator Code or Recovery Code',
  'reauth.hint': 'This verification applies only to the current action and expires after 5 minutes.',
  'reauth.action.tenant_security': 'You are changing the company login security policy.',
  'reauth.action.ip_allowlist': 'You are changing the networks allowed to access company administration.',
  'reauth.action.account_password': 'You are changing the account password. All previous sessions will be signed out.',
  'reauth.action.account_mfa': 'You are changing the account’s two-factor authentication method.',
  'reauth.action.role_access': 'You are changing a role and its permissions.',
  'reauth.action.member_access': 'You are changing a team member’s access.',
  'reauth.action.agent_credential': 'You are creating or revoking Agent credentials.',
  'reauth.action.mfa_recovery': 'You are starting two-factor authentication recovery for a team member.',
  'reauth.action.default': 'You are performing a high-risk action.',
  'reauth.replaced': 'A newer verification request has replaced this one.',
  'reauth.cancelled': 'Identity verification was canceled.',
  'reauth.not_ready': 'Identity verification is not ready yet.',
  // Common
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.saved': 'Saved',
}
